import { render, staticRenderFns } from "./SimplifiedEditingWorkspaceVersion.vue?vue&type=template&id=02c5cac6&scoped=true&lang=pug"
import script from "./SimplifiedEditingWorkspaceVersion.vue?vue&type=script&lang=js"
export * from "./SimplifiedEditingWorkspaceVersion.vue?vue&type=script&lang=js"
import style0 from "./SimplifiedEditingWorkspaceVersion.vue?vue&type=style&index=0&id=02c5cac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c5cac6",
  null
  
)

export default component.exports